const angular = require('angular');
const moment = require('moment');
const app = angular.module('learn-directives');
/**
 * Defines the user timeline component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Analyze} Analyze injected to gain access to Analyze Resource
 * @argument {Content} Content injected to gain access to Content Resource
 * @argument {Tracks} Tracks injected to gain access to Tracks Resource
 * @argument {Events} Events injected to gain access to Events Resource
 * @argument {$q} $q injected to gain access to the $q promise module
 */
app.directive('userTimeline', ['Application', '$q', 'Analyze', 'Content', 'Tracks', 'Events', 'Quizzes', 'Assessments', function (Application, $q, Analyze, Content, Tracks, Events, Quizzes, Assessments) {
    return {
      restrict: 'E',
      template: require('../../templates/directives/user-timeline.html'),
      controller: ['$scope', function ($scope) {
        var self = this;
        self.timelineLength = 15;
        self.directory = {};
        self.showItems = [];
        self.showMore = false;
        self.tenseBlock = {
          'views': 'viewed',
          'creations': 'created',
          'modifications': 'modified',
          'shares': 'shared',
          'likes': 'liked'
        };
        self.gonePhrase = {
          'article': 'an article',
          'video': 'a video',
          'file': 'a file',
          'track': 'a track',
          'assessment': 'an assessment',
          'scorm-content': 'a scorm content',
          'imported_content': 'vendor content',
          'event': 'an event',
          'quiz': 'a quiz'
        };

        self.goTo = function(item) {
          if (!item || !item.contentType || !item.contentId) {
            return;
          }
          var route = item.contentType + 's';
          if (item.contentType === 'quiz') {
            route = 'quizzes';
          } 
          if (item.contentType === 'scorm-content') {
            route = 'scorm';
          }
          if (item.contentType === 'imported_content') {
            route = 'imported-content';
          }
          Application.navigation.goTo('/view/' + route + '/' + item.contentId);
        };

        self.showMoreItems = function() {
          self.showMore = false;
          self.showItems = self.activeItems;
        };

        self.initialize = function () {
          self.loading = true;
          var items = ['views', 'creations', 'modifications', 'shares', 'likes'];
          var promises = [];
          var getContent = {
            article: [],
            video: [],
            file: [],
            track: [],
            assessment: [],
            'scorm-content': [],
            imported_content: [],
            event: [],
            quiz: [],
            presentation: []
          };

          for (var i = 0; i < items.length; i++) {
            promises.push(Analyze.userRecent5({subresource: items[i]}).$promise);
          }

          // Get from analyze
          $q.all(promises)
          .then(function(data) {
            var activeItems = [];
            var PositionState = function() {
              return {
                position: null,
                setPosition: function(i) {
                  this.position = i;
                },
                getPosition: function() {
                  return this.position;
                }
              };
            };

            positionState = new PositionState();

            for (var i = 0; i < self.timelineLength; i++) {
              for (var j = 0; j < items.length; j++) {
                if (!data[j][0]) {
                  continue;
                }
                // set position to the first available item
                if (positionState.getPosition() === null) {
                  positionState.setPosition(j);
                  continue;
                }
                // check if each subsequent item is newer than the previous
                if (new Date(data[j][0].created_on) > new Date(data[positionState.getPosition()][0].created_on)) {
                  positionState.setPosition(j);
                }
              }
              var checkPosition = positionState.getPosition();
              if (checkPosition !== null) {
                // add item type to timeline item and push to stack
                data[checkPosition][0].itemType = items[checkPosition];
                activeItems.push(data[checkPosition].shift());
                var currentItem = activeItems[activeItems.length - 1];
                currentItem.formattedDate = moment(currentItem.created_on).fromNow();
                if (currentItem.type && currentItem.document) {
                  currentItem.contentId = currentItem.document;
                  currentItem.contentType = currentItem.type;
                  if (currentItem.contentType === 'media') {
                    getContent['video'].push(currentItem.document);
                  } else {
                    getContent[currentItem.contentType].push(currentItem.document);
                  }
                }
                if (currentItem.content_type && currentItem.content) {
                  currentItem.contentId = currentItem.content;
                  currentItem.contentType = currentItem.content_type==='scorm'?'scorm-content':currentItem.content_type;
                  if (currentItem.contentType === 'media') {
                    getContent['video'].push(currentItem.content);
                  } else {
                    getContent[currentItem.contentType].push(currentItem.content);
                  }
                }
                positionState.setPosition(null);
                continue;
              }
              break;
            }
            
            var contentPromises = [];
            var totalContent = getContent.article.concat(getContent.file, getContent.video, getContent['scorm-content'], getContent.imported_content);

            contentPromises.push(Content.find({_id: '$in,' + totalContent.length + ',' + totalContent.join(','), limited: true}).$promise);
            contentPromises.push(Tracks.find({_id: '$in,' + getContent.track.length + ',' + getContent.track.join(','), fields: 'name'}).$promise);
            contentPromises.push(Events.find({_id: '$in,' + getContent.event.length + ',' + getContent.event.join(','), fields: 'title'}).$promise);
            contentPromises.push(Assessments.find({_id: '$in,' + getContent.assessment.length + ',' + getContent.assessment.join(','), fields: 'title'}).$promise);
            contentPromises.push(Quizzes.find({_id: '$in,' + getContent.quiz.length + ',' + getContent.quiz.join(','), fields: 'title'}).$promise);
            $q.all(contentPromises)
            .then(function(data) {
              var allItems = [].concat(data[0].data, data[1], data[2], data[3]);
              for (var i = 0; i < allItems.length; i++) {
                self.directory[allItems[i]._id.toString()] = allItems[i];
              }
              //remove items that have since been deleted
              for (i = activeItems.length - 1; i >= 0; --i) {
                !self.directory[activeItems[i].contentId] && activeItems.splice(i, 1);
              }

              self.activeItems = activeItems;

              //limit initial display to 5 items
              if (activeItems.length > 5) {
                self.showItems = activeItems.slice(0,5);
                self.showMore = true;
              } else {
                self.showItems = activeItems.slice(0);
              }

              self.loading = false;
            });
          });
        };
        self.initialize();
      }],
      controllerAs: 'timeline'
    };
  }]);

